import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const ToastService = {
  success: (message, options = {}) =>
    toast.success(message, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "colored",
      ...options
    }),

  error: (message, options = {}) =>
    toast.error(message, { position: "top-center", autoClose: 3000, theme: "colored", ...options }),

  info: (message, options = {}) =>
    toast.info(message, { position: "top-center", autoClose: 3000, theme: "colored", ...options }),

  warning: (message, options = {}) =>
    toast.warning(message, { position: "top-center", autoClose: 3000, theme: "colored", ...options }),
};

export default ToastService;
